import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Divider, Grid, Header, Segment } from "semantic-ui-react";
import { useMediaQuery } from "react-responsive";
import { closeModal, openModal } from "../../../app/common/modals/modalSlice";
import ModalWrapper from "../../../app/common/modals/modalWrapper";

export default function DualAgentModal({ transaction }) {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width:768px)" });
  const { currentUserProfile } = useSelector((state) => state.profile);

  function handleCreateAndLink() {
    dispatch(
      closeModal({
        modalType: "DualAgentModal",
      })
    );
    dispatch(
      openModal({
        modalType: "DualAgentCreateBuyerModal",
        modalProps: { sellerTransaction: transaction },
      })
    );
  }

  function handleLinkExisting() {
    dispatch(
      closeModal({
        modalType: "DualAgentModal",
      })
    );
    dispatch(
      openModal({
        modalType: "DualAgentLinkExistingModal",
        modalProps: { sellerTransaction: transaction },
      })
    );
  }

  function handleClose() {
    dispatch(
      closeModal({
        modalType: "DualAgentModal",
      })
    );
  }

  return (
    <ModalWrapper size="small">
      <Segment>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16} className="zero bottom padding">
              <Header as="h2" color="blue" className="zero bottom margin">
                I am handling both sides...
              </Header>
              <Divider className="zero bottom margin" />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <p className="text-medium">
                Choose how you would like to set up the buyer side of this
                transaction:
              </p>
              <Divider className="medium top margin" />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Button
                type="button"
                // floated={isMobile ? null : "right"}
                color="blue"
                onClick={handleCreateAndLink}
                content="Create Buyer Transaction and link"
                className={
                  isMobile
                    ? "fluid medium bottom margin"
                    : "medium bottom margin"
                }
              />
              <br />
              <Button
                type="button"
                // floated={isMobile ? null : "right"}
                color="blue"
                onClick={handleLinkExisting}
                content={`Link to ${
                  transaction.userId === currentUserProfile.userId
                    ? "my"
                    : transaction.agentProfile?.firstName + "'s"
                } existing Buyer Transaction`}
                className={
                  isMobile
                    ? "fluid medium bottom margin"
                    : "medium bottom margin"
                }
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Button
                onClick={handleClose}
                type="button"
                floated={isMobile ? null : "right"}
                content="Cancel"
                className={isMobile ? "fluid" : null}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </ModalWrapper>
  );
}
